import React, { useMemo } from "react";

export default function PagesVisited({ pageViews }) {
  const { aggregated, totalMs } = useMemo(() => {
    if (!pageViews || pageViews.length === 0)
      return { aggregated: [], totalMs: 0 };

    const map = new Map();
    for (const pv of pageViews) {
      const key = pv.pageName || pv.url || "(unknown)";
      if (!map.has(key)) map.set(key, { pageName: key, totalMs: 0 });
      const entry = map.get(key);
      entry.totalMs += pv.durationMs || 0;
    }

    const rows = Array.from(map.values()).sort(
      (a, b) => b.totalMs - a.totalMs
    );
    return {
      aggregated: rows,
      totalMs: rows.reduce((sum, r) => sum + r.totalMs, 0),
    };
  }, [pageViews]);

  if (!pageViews || pageViews.length === 0) {
    return (
      <p className="text-muted">No page views recorded for this period.</p>
    );
  }

  return (
    <div>
      <div className="data-table-wrapper">
        <table className="table table-sm table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>Page</th>
              <th>% of Total Time</th>
            </tr>
          </thead>
          <tbody>
            {aggregated.map((row) => {
              const pct =
                totalMs > 0 ? Math.round((row.totalMs / totalMs) * 100) : 0;
              return (
                <tr key={row.pageName}>
                  <td>{row.pageName}</td>
                  <td style={{ minWidth: 140 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          height: 6,
                          background: "#e9ecef",
                          borderRadius: 3,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${pct}%`,
                            background: "#0d6efd",
                            borderRadius: 3,
                          }}
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "0.75rem",
                          color: "#6c757d",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {pct}%
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="data-pagination mt-2">
        <span>
          {pageViews.length} page view{pageViews.length !== 1 ? "s" : ""}
          &nbsp;·&nbsp;{aggregated.length} unique page
          {aggregated.length !== 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
}
